export default {"src":"/_next/static/media/vendorPartner.2975e832.svg","height":51,"width":48};